'use client'

import PageNotFound from "@/components/ui/not-found/PageNotFound"


export default function CategoryErrorPage() {

    return (
        <PageNotFound />
    )
}